import { useTranslation } from "react-i18next";
import { Panel } from "primereact/panel";
import NadaConsta from "../../../components/nadaConsta";

export default function AcoesCompletaMensagem({
    mensagem,
}: {
    mensagem: string;
}) {
    const { t } = useTranslation();

    return (
        <Panel header={t("acoesCompleta")}>
            <NadaConsta />
        </Panel>
    );
}
